import { Cell, Row, Skeleton } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { rowClasses } from './user-row.classes';

const UserRowLoading = React.memo(() => {
  return (
    <Row data-loading="true" className={cx(rowClasses({ disabled: true }))} aria-label="Loading user row">
      <Cell className="py-8 px-12 w-full">
        <div className="flex items-center">
          <Skeleton className="h-10 w-48" variant="square" />
        </div>
      </Cell>
    </Row>
  );
});

UserRowLoading.displayName = 'UserRowLoading';

export { UserRowLoading };
